/** English Terms of Use copy (VizHacks public site). */
const termsEn = {
  intro: {
    h2: "Agreement to terms",
    p1: [
      'These Terms of Use ("Terms") govern your access to and use of the website and online services operated by VIZHACKS LTD ("VizHacks", "we", "us", or "our"). By accessing or using the Services, you agree to these Terms. If you do not agree, do not use the Services.',
    ],
    p2: {
      before: "Our",
      privacyLink: "Privacy Policy",
      after:
        "explains how we handle personal information. It forms part of your understanding of how the Services work.",
    },
  },
  services: {
    h2: "The Services",
    p1: "The Services include our public website, enquiry and service-request forms, and related content. Unless we agree otherwise in a separate written contract, use of the website does not by itself create a consulting or client relationship. Any proposal, statement, or estimate provided through the site is indicative only unless confirmed in writing under an agreement between you and VizHacks.",
  },
  acceptable: {
    h2: "Acceptable use",
    p1: "You agree not to:",
    items: [
      "Use the Services in violation of applicable laws or regulations",
      "Submit false, misleading, or fraudulent information, or impersonate any person or entity",
      "Scrape, harvest, data-mine, or systematically copy content from the Services without our prior written consent",
      "Use bots, scripts, or automated means to submit forms, overload systems, or generate excessive traffic",
      "Attempt to gain unauthorised access to our systems, accounts, data, or networks, or probe, scan, or test vulnerabilities without authorisation",
      "Introduce malware, interfere with the operation of the Services, or harm other users or third parties",
      "Upload or transmit unlawful, defamatory, harassing, hateful, or otherwise objectionable content",
    ],
    p2: "We may investigate suspected violations and cooperate with law enforcement. We may suspend or terminate access, remove content, or block submissions where we reasonably believe these Terms have been breached or where necessary to protect the Services.",
  },
  monitoring: {
    h2: "Security monitoring",
    p1: "To protect the Services, we may use technical measures including logging, rate limiting, filtering, and analysis of traffic and submissions. By using the Services, you acknowledge that such measures may be applied in line with our Privacy Policy.",
  },
  ip: {
    h2: "Intellectual property",
    p1: "The Services, including text, graphics, logos, layouts, and software, are owned by VizHacks or our licensors and are protected by intellectual property laws. Except for temporary copies needed to browse the site, you may not copy, modify, distribute, or create derivative works without our prior written permission.",
  },
  disclaimer: {
    h2: "Disclaimer",
    p1: 'The Services are provided on an "as is" and "as available" basis to the fullest extent permitted by law. We disclaim all warranties, whether express, implied, or statutory, including implied warranties of merchantability, fitness for a particular purpose, and non-infringement. We do not warrant that the Services will be uninterrupted, error-free, or free of harmful components.',
  },
  liability: {
    h2: "Limitation of liability",
    p1: "To the fullest extent permitted by applicable law, VizHacks and its directors, employees, and affiliates shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits, data, goodwill, or business opportunities, arising out of or related to your use of the Services, even if we have been advised of the possibility of such damages.",
    p2: "Nothing in these Terms excludes or limits liability that cannot be excluded or limited under applicable law (including liability for death or personal injury caused by negligence, or fraud).",
  },
  indemnity: {
    h2: "Indemnity",
    p1: "To the extent permitted by law, you agree to indemnify and hold harmless VizHacks from claims, damages, losses, and expenses (including reasonable legal fees) arising from your use of the Services, your content or submissions, or your breach of these Terms.",
  },
  law: {
    h2: "Governing law and jurisdiction",
    p1: "These Terms are governed by the laws of England and Wales, without regard to conflict-of-law principles. The courts of England and Wales shall have exclusive jurisdiction over disputes arising from or relating to these Terms or the Services, subject to any mandatory rights you may have as a consumer in your country of residence.",
  },
  changes: {
    h2: "Changes",
    p1: 'We may modify these Terms at any time. We will update the "Last updated" date on this page when we make material changes. Your continued use of the Services after changes become effective constitutes acceptance of the revised Terms. If you do not agree, you must stop using the Services.',
  },
  contact: {
    h2: "Contact",
    p1: {
      before: "Questions about these Terms can be sent through our",
      linkLabel: "contact form",
      after: "or using the company details shown in the website footer.",
    },
    address: ["VIZHACKS LTD", "167–169 Great Portland Street, 5th Floor", "London, W1W 5PF, England"],
  },
};

export default termsEn;
